<template>
  <div style="height: 100%">
    <top-banner :data="data" v-if="dataLen">
      <h2 class="banner-title" slot="banner-title">
        {{ $store.state.voteText }}排行榜
      </h2>
      <p class="banner-content" slot="banner-content">{{ data.etime }}结束</p>
    </top-banner>
    <rank-list></rank-list>
  </div>
</template>



<script>
import TopBanner from "../components/TopBanner";
import RankList from "../components/RankList";

export default {
  name: "",
  data() {
    return {
      apiParams: {
        id: "",
        isPreview: 0,
        isLoading: false
      },
    };
  },
  components: {
    TopBanner,
    RankList,
  },
  computed: {
    data() {
      return this.$store.state.voteInfo;
    },
    dataLen() {
      return Object.keys(this.data).length;
    },
    type() {
      // 1 投票组 0 普通投票
      return this.data.vote_list && this.data.vote_list.length ? 1 : 0;
    },
  },
  methods: {},
  created() {
    // console.log("rank this.data", this.data);
    // console.log("rank this.type", this.type);
  },
  watch: {},
};
</script>

<style>

</style>